module.exports = __webpack_public_path__ + "img/a5f3785.jpg";